import { useState } from "react";
import useHttp from "./use_http";
import moment from "moment";

const useTransactions = () => {
  const { httpService } = useHttp();

  const [loadings, setLoadings] = useState({
    getTransactions: false,
    getRefunds: false,
  });
  const [getCoursesLoading, setGetCoursesLoading] = useState(false);

  const [filters, setFilters] = useState({
    courseId: null,
    date: null,
  });

  const [paginates, setPaginates] = useState({
    current: 1,
    total: 1,
  });

  const [courses, setCourses] = useState([]);
  const [transactionsData, setTransactionsData] = useState([]);
  const [refundsData, setRefundsData] = useState([]);

  const getCourses = async () => {
    let paramsData = {
      page: 1,
      limit: 100,
    };
    try {
      setGetCoursesLoading(true);
      const response = await httpService.get("instructor/course/list", {
        params: paramsData,
      });
      setGetCoursesLoading(false);
      if (response.data.courses) {
        setCourses(response.data.courses);
      } else {
        setCourses([]);
      }
    } catch ({ err, response }) {
      setGetCoursesLoading(false);
    }
  };

  const getTransactions = async (page, filters) => {
    let paramsData = {
      page: page,
      limit: 10,
    };
    if (filters.courseId) {
      paramsData["courseId"] = filters.courseId;
    }
    if (filters.date) {
      paramsData["startDate"] = moment(filters.date[0].$d).format("YYYY-MM-DD");
      paramsData["endDate"] = moment(filters.date[1].$d).format("YYYY-MM-DD");
    }
    try {
      setLoadings({ ...loadings, getTransactions: true });
      const response = await httpService.get(
        "instructor/dashboard/transactions",
        {
          params: paramsData,
        },
      );
      setLoadings({ ...loadings, getTransactions: false });
      setPaginates({
        ...paginates,
        current: parseInt(response.data.page),
        total: response.data.pageCount,
      });
      setTransactionsData(response.data.data);
    } catch ({ err, response }) {
      setLoadings({ ...loadings, getTransactions: false });
    }
  };

  const getRefunds = async (page, filters) => {
    let paramsData = {
      page: page,
      limit: 10,
    };
    if (filters.courseId) {
      paramsData["courseId"] = filters.courseId;
    }
    if (filters.date) {
      paramsData["startDate"] = moment(filters.date[0].$d).format("YYYY-MM-DD");
      paramsData["endDate"] = moment(filters.date[1].$d).format("YYYY-MM-DD");
    }
    try {
      setLoadings({ ...loadings, getRefunds: true });
      const response = await httpService.get("payment/instructor/refund/list", {
        params: paramsData,
      });
      setLoadings({ ...loadings, getRefunds: false });
      setPaginates({
        ...paginates,
        current: response.data.page,
        total: response.data.pageCount,
      });
      setRefundsData(response.data.items);
    } catch ({ err, response }) {
      setLoadings({ ...loadings, getRefunds: false });
    }
  };

  const exports = {
    getCourses,
    getTransactions,
    getRefunds,
    courses,
    transactionsData,
    refundsData,
    filters,
    setFilters,
    paginates,
    loadings,
    getCoursesLoading,
  };
  return exports;
};

export default useTransactions;
